import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';

export function SaturdayTableHU() {  
    return (
      <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
        <Table sx={{ tableLayout: 'auto', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Időpont
              </TableCell>
              <TableCell colSpan={2} sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Program
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center', fontSize: '18px !important' }}>
                Terem
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  8:00 - 11:00
                </Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <Typography sx={{fontSize: '18px !important'}}>
                  <b>Tóth András</b> - Fóti Tanoda
                </Typography>
                <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                  Edufication, avagy a játékról, mint a világ felfedezésének lehetőségéről
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ textAlign: 'center', fontSize: '16px !important' }}>
                  Fsz A
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  8:15
                </Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography sx={{fontSize: '18px !important'}}>
                    <b>Dr. Benda József</b>
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important' }}>
                    Gyermek és Családbarát Magyarországért Alkotó Műhely, Társas Tanulás
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Kreatív közösségfejlesztés nagy létszámú csoportokban
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    ÉLMÉNYWORKSHOP
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{ textAlign: 'center', fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  9:45
                </Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <Typography sx={{ fontWeight: 'bold !important', whiteSpace: "pre-line", textAlign: 'center', fontSize: '18px !important' }}>
                  Szünet
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  10:00
                </Typography>
              </TableCell>
              <TableCell colSpan={2} sx={{ width: '33.33%', verticalAlign: 'top' }}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 5: Fejlesztés játékkal (Elnök: Nemes-Wéber Zsófia)
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Dr. Demeter Gáborné</b> - Magyar Agrár- és Élettudományi Egyetem
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Mese-játék-mozgás összekapcsolódása az olvasási kudarcok megelőzésének módszertanában
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Bertalan Regina Frida & Hencseiné Grain Andrea</b> - Pécsi Tudományegyetem Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    A szótagoló képesség játékos fejlesztése
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Kazinczy Viktória</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    Drámajátékok filozófiai lehetőségei a magyar nyelv tanítása során
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Haffner-Kiss Alexandra</b> - Pécsi Tudományegyetem Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    A zenei játékok pedagógiai jelentősége a digitális kultúrában
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{mt: 2, textAlign: 'center', fontSize: '16px !important' }}>
                  Hildy Péter
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  10:00
                </Typography>
              </TableCell>
              <TableCell colSpan={2} sx={{ width: '33.33%', verticalAlign: 'top' }}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography sx={{fontSize: '18px !important'}}>
                    <b>Czirják Erika</b> - meseterapeuta és meseíró, Pécs
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Mesélni tanulni
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    ÉLMÉNYWORKSHOP
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{mt: 2, textAlign: 'center', fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  11:00
                </Typography>
              </TableCell>
              <TableCell colSpan={2} sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important', whiteSpace: "pre-line", fontSize: '18px !important' }}>
                  Szünet
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  11:15
                </Typography>
              </TableCell>
              <TableCell colSpan={1} sx={{ width: '33.33%', verticalAlign: 'top' }}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 6: A játék varázsa - nyelvtanulás (Elnök: Dr. habil. Schnell Zsuzsanna)
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Fóti Nóra & Radnainé Lőrinczi Szilvia</b> - Pécsi Tudományegyetem, Gyakorló Általános Iskola és Gimnázium
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Mission: Possible — Szabadulj ki a hagyományos nyelvórák fogságából!
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Harrach Ágnes</b> - Kiss Áron Magyar Játék Társaság
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    Miért ne lehetne játékosan is? Nyelvtanítás gyerekeknek és felnőtteknek
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Nemes-Wéber Zsófia</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    Asztali játékok a kultúra, a nyelvtanulás, a szerepjátékok és a logika szolgálatában
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '16px !important' }}>
                    Terem: Fsz A
                  </Typography>
                </Box>
              </TableCell>
              <TableCell colSpan={1} sx={{ width: '33.33%', verticalAlign: 'top' }}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography textAlign='center' fontWeight="bold !important" fontSize='18px !important'>
                    Panel 7: Játék különleges élethelyzetekben (Elnök: Dr. Dr. habil. Agora Zsuzsanna)
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Dr. Bíró Violetta</b> - Pécsi Tudományegyetem KPVK
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    A világjáték néhány jellegzetessége az örökbefogadás kapcsán
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Dr. Kocsisné Dr. habil. Farkas Claudia</b> - Pécsi Tudományegyetem KPVK
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Játék a csenddel...
                  </Typography>
                  
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Gaján Éva</b> - ELTE BTK Filozófiatudományi Doktori Iskola, Film-, média- és kultúraelmélet program
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    "Mi, szentendrei polgárok..." Játék, játékosság a művészetben, a kultúrában a három T idején
                  </Typography>

                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Baumann Beatrix</b> - Pécsi Tudományegyetem, Kultúratudományi, Pedagógusképző és Vidékfejlesztési Kar
                  </Typography>
                  <Typography sx={{fontSize: '16px !important' }}>
                    A koncentrációs táborok játékai
                  </Typography>
                    
                  <Typography sx={{mt: 2, fontSize: '16px !important' }}>
                    Terem: Hildy Péter
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                  11:15
                </Typography>
              </TableCell>
              <TableCell colSpan={2} sx={{ width: '33.33%', verticalAlign: 'top' }}>
                <Box sx={{ whiteSpace: "pre-line" }}>                
                  <Typography sx={{mt: 2, fontSize: '18px !important'}}>
                    <b>Szabó Ildikó</b> - ÉlményMűhely, Pécs
                  </Typography>
                  <Typography sx={{mt: 1, fontStyle: 'italic !important', fontSize: '16px !important' }}>
                    Játékos Matematika és Művészet a Tanulásban
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Typography sx={{mt: 2, textAlign: 'center', fontSize: '16px !important' }}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography>
                    12:15
                </Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <Typography sx={{ whiteSpace: "pre-line", fontWeight: 'bold !important', fontSize: '18px !important' }}>
                  Konferenciazárás, reflexiók, közös játék (Elnökök: Dr. habil. V. Gilbert Edit és Dr. Dr. habil. Agora Zsuzsanna)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ textAlign: 'center', whiteSpace: "pre-line", fontSize: '16px !important'}}>
                  Koltai Dénes Aula
                </Typography>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    );
}

export function SaturdayTableDE() {  
    return (
      <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
        <Table sx={{ tableLayout: 'auto', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Zeit
              </TableCell>
              <TableCell colSpan={3} sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Programm
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Raum
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  8:00
                </Typography>
              </TableCell>
              <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important', fontSize: '25px !important' }}>
                  {`Ankunft\n
                  (Bitte pünktlich ankommen!!!) Eine vorläufige Registration in nötig!
                  Bitte beachten Sie: Das Programm läuft mit einer begrenzter Teilnehmerzahl!
                  `}
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  9:00 - 16:00
                </Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {`Zsuzsanna Majoros-Tóth: Einführung in die Pädagogik von Franz-Kett - ein Erlebnisworkshop\n
                  
                  9.00 - 10.30 Einheit I: NUR für StudentInnen von Uni Pécs
• Einführung und Vorstellung, pädagogisches Bekenntnis
• "Ich bin hier mit anderen zusammen" 
• Franz-Kett-Pädagogik im Kindergartenalltag
• Spielerischer Gebrauch der Franz Kett pädagogischen Werkzeuge im Alltag

Pause: 10.30-11.00

11.00 - 12.30 Einheit II: OFFEN für alle TeilnehmerInnen 
• Der "Mensch mit Herz" (Aneignung von Körperteilen und dazugehörigen Verben)
• Das 4-Phasen-Modell der Franz-Kett-Pädagogik
• Die Besonderheit der Franz-Kett-Pädagogik

Pause: 12.30 - 13.00

13.00 - 14.30 Einheit III: OFFEN für alle TeilnehmerInnen
• Die "Drei Schmetterlinge" Beschäftigung (Märchenbeschäftigung mit Franz Kett Pädagogik)
• Sprachbad, Motivation
• Die Rolle von Tänzen, Liedern, Rhythmus, Reimen-Gedichten-Abzählreimen
• Einheit von Bewegungen, Klängen, Bildern, Wörtern

Pause: 14.30 - 15.00

15.00-16.00 Einheit IV: NUR für StudentInnen von Uni Pécs
• Reflexion über die erlebten Erfahrungen.                  
                  `}
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Künstlerraum (Nagyterem)
                </Typography>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    );
}

export function SaturdayTableUS() {  
    return (
      <TableContainer component={Paper} sx={{ maxWidth: '90%', marginBottom: '40px', mx: 'auto' }}>
        <Table sx={{ tableLayout: 'auto', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Time
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Program
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#a74040', color: '#fff', textAlign: 'center' }}>
                Venue
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: '16px !important', fontWeight: 'bold !important' }}>
                  8:45 AM
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important', fontSize: '25px !important' }}>
                  Morning gathering
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: '16px !important' }}>
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  9:00 AM
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {`Panel 4: Board Games in Education (Chair: Éva Harka)\n
                  	Viktória Karádi - Dr. habil. Virág Rab - Endre Grastyán College for Advanced Studies, University of Pécs, Hungary: 
                    From Play to Progress: A Board Game in Educational and Research Contexts
	
                    Cornelia Katharina Hofmann - Research Unit Laborschule, Universität Bielefeld, Germany: 
                    Effects of Play in the Classroom 
	
                    Dr. Melinda Mihály, Dr. Dorottya Mendly - HUN-REN CERS, Institute for Regional Studies and Corvinus University, Hungary: 
                    Civic Awareness and Environmental Justice: A Bioregional Approach to the Sand Ridge in Hungary

                    Vilja Arató - Power of Humanity Foundation, Hungary: 
                    Gamification in the Service of Social Issues
                  `}
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Dr. Tóth Tibor
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  10:15 AM
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line", textAlign: 'center' }}>
                  Coffee break
                </Typography>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  10:30 AM
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {
                  `Panel 5: Play and Games in the Information Society (Chair: Prof. Dr. Zsolt Nemeskéri)\n
                  	Prof. László Z. Karvalics - Institute of Advanced Studies (IASK/FTI) Hungary: 
                    The Third Mission of Cybertoys
	
                    Dr. László Halász - University of Pécs, Faculty of Cultural Sciences, Education and Rural Development, Philosophy Doctoral School, Hungary: 
                    What is Reality? A Philosophical Investigation of Reality and Simulation
	
                    Dr. Alpaslan Ertüngealp - University of Pécs, Faculty of Cultural Sciences, Education and Rural Development, Philosophy Doctoral School, Hungary: 
                    On the Versatility and Meaning of "Re-" in Games, Arts and Realities

                    Jacob Baltz - "Kiwis in Space" - EVE Online, USA: 
                    Viewing Life Through the Optics of Game: How Humans Play at Immortality Through Corporate Frameworks ONLINE
                  `}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ whiteSpace: "pre-line", fontSize: '16px !important' }}>
                  Dr. Tóth Tibor
                </Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 'bold !important' }}>
                  12:00 PM
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  Takeaway from the Conference 'Play and Society' (Chair: Prof. Dr. Zsolt Nemeskéri)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography sx={{ fontSize: '16px !important' }}>
                  Dr. Tóth Tibor
                </Typography>
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    );
}